import { useNavigate } from "react-router-dom";
import { OnboardingLayout } from "@/components/layout/OnboardingLayout";
import { PrimaryButton } from "@/components/fionova/Primitives";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <OnboardingLayout testId="page-not-found" contentClassName="items-center justify-center py-10 text-center">
      <p className="text-5xl font-semibold text-primary">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-foreground">This page drifted away</h1>
      <p className="mt-2 text-base text-muted-foreground">Let's guide you back.</p>
      <div className="mt-8 w-full max-w-[240px]">
        <PrimaryButton onClick={() => navigate("/")}>Back to start</PrimaryButton>
      </div>
    </OnboardingLayout>
  );
}
